import { render, staticRenderFns } from "./MouMoaDetailModal.vue?vue&type=template&id=06a7f437&scoped=true"
import script from "./MouMoaDetailModal.vue?vue&type=script&lang=js"
export * from "./MouMoaDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MouMoaDetailModal.vue?vue&type=style&index=0&id=06a7f437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7f437",
  null
  
)

export default component.exports